<template>
  <nav v-if="items.length" class="event-nav" aria-label="Event sections">
    <v-container class="event-nav-inner">
      <a
        v-for="item in items"
        :key="item.id"
        :href="`#${item.id}`"
        @click.prevent="scrollToSection(item.id)"
      >{{ item.label }}</a>
    </v-container>
  </nav>
</template>

<script>
export default {
  name: 'EventSectionNav',
  props: { items: { type: Array, default: () => [] } },
  methods: {
    scrollToSection(sectionId) {
      const target = document.getElementById(sectionId);

      if (!target) return;

      window.history.replaceState(null, '', `#${sectionId}`);
      target.scrollIntoView({ behavior: 'smooth', block: 'start' });
    },
  },
};
</script>

<style scoped>
.event-nav { backdrop-filter: blur(14px); background: rgba(5, 5, 5, 0.92); border-bottom: 1px solid #292929; border-top: 1px solid #292929; overflow-x: auto; position: sticky; top: 0; z-index: 8; }
.event-nav-inner { display: flex; gap: 24px; min-width: max-content; padding-bottom: 14px; padding-top: 14px; }
.event-nav a { color: #c9c9c9; font-family: "Oswald", sans-serif; font-size: 0.86rem; font-weight: 700; text-decoration: none; text-transform: uppercase; }
.event-nav a:hover, .event-nav a:focus { color: #f0b13c; }
</style>
